import isUnsupportedDateRangeTypeForSplitView from './isUnsupportedDateRangeTypeForSplitView';
import notEnoughCalendarsForSplitView from './notEnoughCalendarsForSplitView';
import loc from 'owa-localize';
import {
    toggleSplitViewText,
    toggleSplitViewDisabledTooltip,
    toggleSplitViewDisabledForOneCalendarTooltip,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';

export default function getSplitViewButtonTooltip(): string {
    if (isUnsupportedDateRangeTypeForSplitView()) {
        return loc(toggleSplitViewDisabledTooltip);
    } else if (notEnoughCalendarsForSplitView()) {
        return loc(toggleSplitViewDisabledForOneCalendarTooltip);
    } else {
        return loc(toggleSplitViewText); // title - used as tooltip
    }
}
